export default __webpack_public_path__ + "d812bfa5273a2e9cd0ca1c8569237655.png";